export const testPeriods: Array<number> = [ 1, 3, 6, 12 ]
